import * as faceapi from 'face-api.js';

const MODEL_URL = '/models';
let modelsLoaded = false;

export const loadModels = async () => {
  if (modelsLoaded) return;
  await Promise.all([
    faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
    faceapi.nets.faceLandmark68TinyNet.loadFromUri(MODEL_URL),
    faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
    faceapi.nets.faceExpressionNet.loadFromUri(MODEL_URL)
  ]);
  modelsLoaded = true;
};

export const detectFace = async (videoElement) => {
  const detection = await faceapi
    .detectSingleFace(videoElement, new faceapi.TinyFaceDetectorOptions())
    .withFaceLandmarks(true)
    .withFaceDescriptor();
  return detection;
};

export const getFaceDescriptor = async (videoElement) => {
  const detection = await detectFace(videoElement);
  if (!detection) return null;
  return { descriptor: Array.from(detection.descriptor), detection };
};

export const compareFaces = (descriptor1, descriptor2) => {
  const d1 = new Float32Array(descriptor1);
  const d2 = new Float32Array(descriptor2);
  return faceapi.euclideanDistance(d1, d2);
};

export const findBestMatch = (queryDescriptor, labeledDescriptors, threshold = 0.5) => {
  const query = new Float32Array(queryDescriptor);
  let bestMatch = null;
  let bestDistance = Infinity;

  for (const item of labeledDescriptors) {
    const distance = faceapi.euclideanDistance(query, new Float32Array(item.descriptor));
    if (distance < bestDistance) {
      bestDistance = distance;
      bestMatch = item;
    }
  }

  if (bestDistance <= threshold) {
    return {
      match: bestMatch,
      distance: bestDistance,
      confidence: Math.round((1 - bestDistance) * 100)
    };
  }
  return null;
};
